import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from '../../modules/listas/services/auth.service';
import { Observable, of, from } from 'rxjs';
import { ModalNotificationService } from '../../modules/listas/services/modal-notification.service';


@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {
  constructor(private readonly modalNotificationService: ModalNotificationService, private readonly authService: AuthService, private readonly router: Router) { }

  private showFailureConetionError(error: any): void {
    this.modalNotificationService.openModal({
      category: 'failure',
      tittle: 'Acceso Denegado',
      description: error?.error?.message ?? 'Error inesperado',
    });
  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const role = this.authService.getRoleFromToken();
    if (!role) {
      console.warn('⚠️ No hay rol en el token, redirigiendo al login');
      this.router.navigate(['/login']);
      return of(false);
    }
    return from((this.authService.allowedMenuOptions?.length == 0 ? this.authService.fillAllowMenuOptions() : Promise.resolve())
      .then(() => {

        const url = (state.url || '').split('?')[0].split('#')[0];;
        const validRoute = this.authService.allowedMenuOptions.some(opt => url.includes(String(opt.code)));
        if (validRoute) {
          console.log(`✅ Acceso permitido para el rol ${role} a la ruta ${route.routeConfig?.path}`);
          return true;
        } else {
          console.warn(`❌ Acceso denegado para el rol ${role} a la ruta ${route.routeConfig?.path}, redirigiendo al menú principal`);
          this.showFailureConetionError({ error: { message: 'No tienes permisos para acceder a esta ruta.' } });
          this.router.navigate(['/menu']);
          return false;
        }
      })
    );
  }
}
